import React, { useState, useEffect } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { designationOptions } from "../../options/designationOptions";
import { formatToDateOnly } from "../../utils/helpers";
import { ThreeDots } from "react-loader-spinner";
import axios from "axios";
import { StatusEnum } from "../../constants/employeeStatusEnum";
import StatusOptions from "../../options/employeeStatusOptions";
import { API_SHADOW_RESOURCES } from "../../config/Endpoints";
import { useShadowEmployeeStore } from "../../stores/shadowEmployeeListStore";
export const AddMemberFormModal = ({
  show,
  closeModal,
  addMember,
  project,
  shadowEmployeeList,
  mainEmployeeList,
  isLoading,
}) => {
  const initialFormState = {
    shadowEmployee: null,
    mainEmployee: null,
    designation: null,
    joiningDate: null,
    endDate: null,
  };

  const [form, setForm] = useState(initialFormState);

  const calculateStatus = (joinDate, endDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (endDate) {
      const end = new Date(endDate);
      end.setHours(0, 0, 0, 0);
      return end > today ? StatusEnum.ACTIVE : StatusEnum.INACTIVE;
    }
    return joinDate ? StatusEnum.ACTIVE : "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const joinDate = form.joiningDate;
    const endDate = form.endDate;

    if (joinDate && endDate) {
      if (endDate < joinDate) {
        toast.error("End date must be after joining date!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
    }
    await addMember({
      shadowEmployeeId: form.shadowEmployee?.value,
      mainEmployeeId: form.mainEmployee?.value,
      designation: form.designation?.value,
      joiningDate: formatToDateOnly(form.joiningDate),
      endDate: form.endDate ? formatToDateOnly(form.endDate) : null,
      status: form.status,
    });
  };
  useEffect(() => {
    if (!show) {
      setForm(initialFormState);
    }
  }, [show]);

  if (!show) return null;
  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content rounded-lg">
          <div className="modal-header">
            <h5 className="modal-title">Add Shadow Member</h5>
            <button type="button" className="btn-close" onClick={closeModal} />
          </div>

          <form onSubmit={handleSubmit}>
            <div
              className="modal-body py-5 px-4"
              style={{ backgroundColor: "#fafbff" }}
            >
              <div className="container-fluid">
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    {/* Shadow Employee */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label className="form-label mb-0">
                          Shadow Employee *
                        </label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          placeholder="Select Shadow Employee"
                          options={shadowEmployeeList}
                          isSearchable
                          value={form.shadowEmployee}
                          onChange={(v) =>
                            setForm((p) => ({
                              ...p,
                              shadowEmployee: v ? v : "",
                            }))
                          }
                          isClearable
                          required
                        />
                      </div>
                    </div>

                    {/* Main Employee */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label className="form-label mb-0">
                          Main Employee *
                        </label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          placeholder="Select Main Employee"
                          options={mainEmployeeList}
                          value={form.mainEmployee}
                          onChange={(v) =>
                            setForm((p) => ({ ...p, mainEmployee: v ? v : "" }))
                          }
                          isClearable
                          required
                        />
                      </div>
                    </div>

                    {/* Designation */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label className="form-label mb-0">
                          Shadow Resource Designation *
                        </label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          placeholder="Select Designation"
                          options={designationOptions}
                          value={form.designation}
                          onChange={(v) =>
                            setForm((p) => ({ ...p, designation: v ? v : "" }))
                          }
                          isClearable
                          required
                        />
                      </div>
                    </div>

                    {/* Joining Date */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label className="form-label mb-0">
                          Joining Date *
                        </label>
                      </div>
                      <div className="col-md-8">
                        <DatePicker
                          selected={form.joiningDate}
                          onChange={(d) =>
                            setForm((p) => ({
                              ...p,
                              joiningDate: d,
                              status: calculateStatus(d, p.endDate),
                            }))
                          }
                          showIcon
                          toggleCalendarOnIconClick
                          placeholderText="mm/dd/yyyy"
                          minDate={
                            project?.sowStartDate
                              ? new Date(project.sowStartDate)
                              : null
                          }
                          maxDate={
                            project?.sowEndDate
                              ? new Date(project.sowEndDate)
                              : null
                          }
                          onKeyDown={(e) =>
                            e.key !== "Backspace" &&
                            e.key !== "Delete" &&
                            e.preventDefault()
                          }
                          className="border"
                          required
                        />
                      </div>
                    </div>

                    {/* End Date */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label className="form-label mb-0">End Date</label>
                      </div>
                      <div className="col-md-8">
                        <DatePicker
                          selected={form.endDate}
                          onChange={(d) =>
                            setForm((p) => ({
                              ...p,
                              endDate: d,
                              status: calculateStatus(p.joiningDate, d),
                            }))
                          }
                          showIcon
                          toggleCalendarOnIconClick
                          placeholderText="mm/dd/yyyy"
                          minDate={
                            form.joiningDate ||
                            (project?.sowStartDate
                              ? new Date(project.sowStartDate)
                              : null)
                          }
                          maxDate={
                            project?.endDate
                              ? new Date(project.endDate)
                              : project?.sowEndDate
                              ? new Date(project.sowEndDate)
                              : null
                          }
                          onKeyDown={(e) =>
                            e.key !== "Backspace" &&
                            e.key !== "Delete" &&
                            e.preventDefault()
                          }
                          className="border"
                        />
                      </div>
                    </div>

                    {/* Status */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label className="form-label mb-0">Status</label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          options={StatusOptions}
                          value={
                            StatusOptions.find(
                              (o) => o.value === form.status
                            ) || null
                          }
                          isDisabled
                          placeholder="Select Status"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer rounded-lg-bottom">
              <button
                type="button"
                className="btn btn-secondary px-4 py-2"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn theme-button"
                disabled={isLoading}
              >
                {isLoading ? (
                  <ThreeDots
                    height="25"
                    width="80"
                    radius="9"
                    color="white"
                    ariaLabel="three-dots-loading"
                    visible={true}
                  />
                ) : (
                  "Add Member"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export const AddMembers = ({
  project,
  shadowEmployeeList,
  onMemberAdded,
  mainEmployeeList,
  teamMembersList,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const { setShadowEmployeeList } = useShadowEmployeeStore();

  const openModal = async () => {
    document.body.style.overflow = "hidden";
    setShowModal(true);
  };
  const closeModal = () => {
    document.body.style.overflow = "";
    setShowModal(false);
  };
  const addMember = async (data) => {
    setIsLoading(true);
    try {
      const accessToken = Cookies.get("accessToken");
      const payload = {
        shadowEmployeeId: data.shadowEmployeeId,
        workingEmployeeId: data.mainEmployeeId,
        projectId: project.projectId,
        joiningDate: data.joiningDate,
        endDate: data.endDate,
        status: data.status,
        designation: data.designation,
        createdBy: String(userData?.id),
      };

      const res = await axios.post(API_SHADOW_RESOURCES, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      toast.success(res?.data?.message || "Member assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (onMemberAdded) {
        const shadowEmp = shadowEmployeeList.find(
          (e) => e.value === data.shadowEmployeeId
        );
        const mainEmp = mainEmployeeList.find(
          (e) => e.value === data.mainEmployeeId
        );

        onMemberAdded({
          ...res?.data?.data,
          shadowEmployeeName: shadowEmp?.label || "",
          workingEmployeeName: mainEmp?.label || "",
        });
      }
      setShadowEmployeeList(
        shadowEmployeeList.filter((e) => e.value !== data.shadowEmployeeId)
      );
      closeModal();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {project.status !== 1 && (
        <button
          className="btn theme-button"
          onClick={openModal}
          disabled={
            !teamMembersList ||
            teamMembersList.length === 0 ||
            project.status === 2
          }
        >
          Add Member
        </button>
      )}

      <AddMemberFormModal
        show={showModal}
        closeModal={closeModal}
        addMember={addMember}
        project={project}
        shadowEmployeeList={shadowEmployeeList}
        mainEmployeeList={mainEmployeeList}
        isLoading={isLoading}
      />
    </>
  );
};

export default AddMembers;
